<template>
    <div class="warpper">
        <div class="flex align-center justify-between">
            <div class="page-title">{{detail.title}}</div>
            <div class="page-back" @click="toBack">返回</div>
        </div>
        <empty v-if="!detail.content" :type="0"/>
        <div class="margin-top" v-html="detail.content"></div>
    </div>
</template>

<script>
    import {getArticle} from '@/api/member'
    export default {
        name: "ship",
        data() {
            return {
                type:'',
                detail:''
            }
        },
        created() {
            this.$emit('setIndex', [0], '会员说明')
            this.type = this.$route.query.type
            this.init()
        },
        computed: {},
        methods: {
            //  页面加载时请求
            async init() {
                let _data = await getArticle(this.type)
                if (_data.status === 200){
                    this.detail = _data.data
                }
            },
            toBack(){
                this.$router.go(-1)
            }
        }

    }
</script>

<style scoped lang="scss">
    .warpper {
        background-color: #ffffff;
        border-radius: 10px;
        padding: 20px;
    }

</style>